import { Button, message } from 'antd'
import { useState } from 'react'

import { AppAdmin } from 'api/app-admin'
import { TokenizeMintStatusEnum } from 'constants/pto'
import { logError } from 'utils/logger'

interface ButtonMintPTOProps {
  id: string
  mintStatus?: TokenizeMintStatusEnum
  onSuccess?: () => Promise<void>
}

const BUTTON_CONFIG: Record<number, { label: string; color: string; variant: string }> = {
  [TokenizeMintStatusEnum.IDLE]: { label: 'Pre-mint PTO', color: 'primary', variant: 'solid' },
  [TokenizeMintStatusEnum.MINTING]: { label: 'Minting...', color: 'primary', variant: 'solid' },
  [TokenizeMintStatusEnum.COMPLETED]: {
    label: 'Minted',
    color: 'primary',
    variant: 'solid',
  },
  [TokenizeMintStatusEnum.FAILED]: { label: 'Retry Mint', color: 'danger', variant: 'solid' },
}

const ButtonMintPTO = ({ id, mintStatus, onSuccess }: ButtonMintPTOProps) => {
  const [loading, setLoading] = useState(false)

  if (mintStatus == null) return null

  const isMinting = mintStatus === TokenizeMintStatusEnum.MINTING
  const isCompleted = mintStatus === TokenizeMintStatusEnum.COMPLETED
  const isDisabled = isMinting || isCompleted

  const config = BUTTON_CONFIG[Number(mintStatus)]
  if (!config || isCompleted) return null

  const handleMint = async (e: React.MouseEvent) => {
    e.preventDefault()

    try {
      setLoading(true)

      const res = await AppAdmin.ptoMint(id)

      if (res?.data?.success) {
        message.success('Mint PTO successfully')
        await onSuccess?.()
      }
    } catch (error) {
      message.error('Error while minting PTO')
      logError('Mint PTO error:', error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <Button
      color={config.color as any}
      variant={config.variant as any}
      loading={loading || isMinting}
      disabled={isDisabled}
      onClick={handleMint}
    >
      {config.label}
    </Button>
  )
}

export default ButtonMintPTO
